import React from 'react';
import s from '../QuantQual.module.css';
import common from '../../../../../styles/common-styles.module.css';
import ColorBlock from '../../../../../components/ColorBlock/ColorBlock';

const getRange = (value) => {
  if (value >= 0.80) {
    return 'high';
  }

  if (value >= 0.60) {
    return 'intermediate';
  }

  return 'low';
};

const getAVGScoreColumn = (item, value) => {
  if (item[value] === -1) {
    return (
      <div>—
        <span className={common.screenReaderText}>no data</span>
      </div>
    );
  }
  return (
    <div>
      <ColorBlock
        value={item[value]}
        mediumRangeMinValue={0.6}
        highRangeMinValue={0.8}
        className={s.colorBlock}
        aria-label={`${getRange(item[value])} performance`}
      >
        {`${Math.round(item[value] * 100)}%`}
      </ColorBlock>
      <span className={common.screenReaderText}>
        {`${getRange(item[value])} performance`}
      </span>
    </div>
  );
};

export {
  getAVGScoreColumn,
  getRange,
};
